<app-pencil-button
  theme="icon"
  icon="menu"
  [iconConfig]="{ type: IconTypes.materialIcon }"
  class="top-bar__menu-button"
  aria-label="Open navigation menu"
  (clickEvent)="onMenuClick()"
></app-pencil-button>

<span *ngIf="title" class="top-bar__title">{{ title }}</span>

<app-profile-photo
  class="cursor-pointer"
  [width]="30"
  [showStatus]="true"
  [hasMenu]="true"
  [isClickEnabled]="false"
></app-profile-photo>
